module.exports = __webpack_public_path__ + "img/shield-bios-banner-02.80a3807e.jpg";